import changeCart from '../lib/changeCart';
import removeAddonLineItem from '../lib/removeAddonLineItem';

const initCart = () => {
  const cartPageContainer = document.querySelector('[data-cart-page]');
  const removeBtnEls = cartPageContainer.querySelectorAll('[data-cart-remove-item]');
  if (!removeBtnEls.length) return;

  const spinnerEl = cartPageContainer.querySelector('[data-loading-spinner]');
  removeBtnEls.forEach(btn => {
    btn.addEventListener('click', async (evt) => {
      evt.preventDefault();
      const lineItemKey = btn.dataset.cartRemoveItem;
      if (!lineItemKey) return;

      try {
        cartPageContainer.classList.add('opacity-50', 'pointer-events-none');
        spinnerEl?.classList.remove('hidden');
        await changeCart(lineItemKey, 0);
        await removeAddonLineItem(lineItemKey);
        window.location.reload();
      } catch (err) {
        console.error('Error removing line item and add-on:', err);
      }
    });
  });
};

export default initCart;
